import React from "react";
import "./Hero.css";
import { FaDribbble, FaGithub, FaInstagram } from "react-icons/fa6";
import Typewriter from "typewriter-effect";

const Hero = () => {
  return (
    <div className="Row">
      <img src="/Assets/Ellipse.png" alt="" className="ellipse" />
      <div className="Content-Wrapper">
        <h1 className="Content-Title">
          HEY! <span className="Name">I'm Rizqi,</span> A<br></br>{" "}
          <span className="Typing-Text">
            <Typewriter
              options={{
                autoStart: true,
                loop: true,
                delay: 100,
                strings: [
                  "UI/UX Designer",
                  "Front End Developer",
                  "Wordpress Developer",
                ],
              }}
            />
          </span>
        </h1>
        <p className="Content-Subtitle">
          As a boy who's passionate about design and coding.<br></br> I have
          been designing and making website around one years.
        </p>
        <div className="Row-Button">
          <button
            className="Contacts-Button"
            onClick={() =>
              (window.location.href = "mailto:shoqibulatzmi@gmail.com")
            }
          >
            CONTACT ME
          </button>
          <a
            href="https://dribbble.com/rizatzmi"
            target="_blank"
            rel="noreferrer"
          >
            <FaDribbble className="Icon-Button" />
          </a>
          <a href="https://github.com/Rizatzmi">
            <FaGithub className="Icon-Button" />
          </a>
          <a href="https://www.instagram.com/ui.rizatzmi/">
            <FaInstagram className="Icon-Button" />
          </a>
        </div>
      </div>
      <div className="Image-Wrapper">
        <img className="Hero-Image" src="/Assets/Hero-Image.png" alt="" />
      </div>
    </div>
  );
};

export default Hero;
